/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchActorsSkeleton.defs.js'
export * as $defs from './searchActorsSkeleton.defs.js'
